export const getThemeMap = (context) => {
	const mapOfThemes = new Map();

	context.keys().forEach((key) => {
		const id = key
			.replace(/^.\/\d\d-/, "")
			.replace(/(.jpg|.png)/, "")
			.replace("_thumb", "")
			.replace("_preview", "");
		const file = context(key).default;
		const spaces = id.split("-").join(" ");
		const description = spaces;

		const image = {
			file,
			description,
		};
		mapOfThemes.set(id, image);
	});

	return mapOfThemes;
};
